import React, { useMemo } from 'react';
import { styled as styled2 } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import type { Holiday } from '../../../../common/types';
import { Row, Column } from '../../../../common/ui/styled';
import { formatDate } from '../../../../common/utils/calendars/utils';
import messages from './messages';

type Props = {
	holiday: Holiday;
} & Intl;

export const HolidayRowView = ({ intl: { formatMessage }, holiday }: Props) => {
	const locale = useLocale().replace('_', '-');
	const { name, iso8601Date, isRecurring } = holiday;
	const prefix = formatMessage(messages.every);
	const formattedDate = useMemo(
		() => formatDate({ iso8601Date, locale, isRecurring, message: prefix }),
		[iso8601Date, locale, isRecurring, prefix],
	);
	return (
		<HolidaysGrid>
			<Row data-testid={`servicedesk-sla-settings.ui.calendars.calendar.holidays.grid-row-${name}`}>
				<Column>{name}</Column>
				<Column>{formattedDate}</Column>
				<Column>{formatMessage(isRecurring ? messages.annually : messages.oneTime)}</Column>
			</Row>
		</HolidaysGrid>
	);
};

export const HolidayView = injectIntl(HolidayRowView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HolidaysGrid = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.DN0),
	marginTop: token('space.100', '8px'),
});
